<template>
	<v-dialog persistent @click:outside="closeDialog()" v-model="dialog" max-width="700" content-class="test-class">
		<v-card >
			<v-card-title>
				{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.video.header')}}
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text :key="key" class="py-3">
				<div v-if="!file" class="drop-area text-center relative">
					<div class="file-input">
						<input type="file" accept="video/*" id="attach-video__file-input" class="fileinput" @change="selectFile"/>
					</div>

					<label class="my-5 v-btn v-btn--has-bg theme--light elevation-0 v-size--x-large accent" for="attach-video__file-input">
						{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.video.get')}}
					</label>
					<div class="font-16 bold">
						{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.video.drag')}}
					</div>
					<div class="mt-3 text-accent font-14">
						{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.video.size')}} {{ videoValidation.size }}MB
					</div>
				</div>
			</v-card-text>
			<v-card-actions class="justify-content-center py-7">
				<v-btn color="light" elevation="0" @click="closeDialog()">{{ $vuetify.lang.t('$vuetify.cancel')}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
	data() {
		return {
			dialog: false,
			src: null,
			file: null,
			key: 0,
		}
	},
	computed: {
		...mapGetters({
			videoValidation: 'validation/videos'
		}),
		maxSize() {
			return this.videoValidation.size * 1024 * 1024;
		}
	},
	methods: {
		selectFile(e) {
			this.file = e.target.files[0];
			if(this.file.size > this.maxSize) {
				this.$toast.error(`Plik jest zbyt duży. Maksymalny rozmiar to ${this.videoValidation.size}MB`);
			}
			else {
				this.save()
			}
		},
		save() {
			if(this.file) {
				this.$emit('selected', this.file);
				this.closeDialog();
				return true;
			}
			this.$toast.error('Wybierz film!');
			return false
		},
		showDialog() {
			this.dialog = true;
		},
		closeDialog() {
			this.clear();
			this.dialog = false;
			this.$emit('closed');
		},
		previewVideo(){
			let reader = new FileReader();

			reader.readAsDataURL( this.file );
			const t = this;
			reader.addEventListener('load', function(){
				t.src = reader.result;
			});
		},
		clear() {
			this.file = null;
			this.src = null;
			this.key++;
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
